import { useEffect, useState } from "react";
import api from "../lib/Urls";
import { CLOUDINARY_PURPOSES, uploadDirectToCloudinary } from "../lib/cloudinaryUpload";
import ImageUploader from "../components/ImageUploader";
import NavBar from "../components/Navbar";
import Footer from "../components/Footer";
import {useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { getStoredUserId } from "../lib/authStorage";



const PostItem = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState(null);
  const navigate = useNavigate();
  const [userId, setUserId] = useState(null);
  const location = useLocation();
  const prefill = location.state;
  const isPrefilled = !!location.state;
  const types = ["seller", "donator", "giveaway"];

  const [form, setForm] = useState({
    itemName: "",
    description: "",
    locCountry: "",
    locCity: "",
    store: "",
    amount: "",
    currency: "",
    type: "",
    availPeriod: "",
    categoryName: ""
  });

  const [availabilityUnit, setAvailabilityUnit] = useState("hours");

  useEffect(() => {
    api.get("/api/categories")
      .then(res => setCategories(res.data))
      .catch(err => console.log(err));

    const storedId = getStoredUserId();
    if (storedId) {
      setUserId(storedId);
    }


    if (prefill) {
      setForm(prev => ({
        ...prev,
        categoryName: prefill.category
          ? prefill.category.replace(/-/g, " ")
          : "",
        type: prefill.type || ""
      }));
    }

  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      let imageUrl = null;

      if (image) {
        const uploaded = await uploadDirectToCloudinary(
          image,
          CLOUDINARY_PURPOSES.ITEM_IMAGE
        );
        imageUrl = uploaded.secureUrl;
      }

      const formData = new FormData();

      if (userId) {
        formData.append("userId", String(userId));
      }

      Object.keys(form).forEach((key) => {
        if (!["availPeriod", "locCountry", "locCity"].includes(key)) {
          formData.append(key, form[key]);
        }
      });

      const availabilityValue = Number(form.availPeriod);
      const availabilityMultipliers = {
        hours: 1,
        days: 24,
        months: 24 * 30,
        years: 24 * 365,
      };

      const availabilityHours =
        availabilityValue * availabilityMultipliers[availabilityUnit];

      formData.append("availPeriod", String(availabilityHours));

      if (imageUrl) {
        formData.append("imageUrl", imageUrl);
      }

      await api.post("/api/category-items", formData);

      const destinationCategory = form.categoryName;
      alert("Item posted successfully!");

      setForm({
        itemName: "",
        description: "",
        locCountry: "",
        locCity: "",
        store: "",
        amount: "",
        currency: "",
        type: "",
        availPeriod: "",
        categoryName: "",
      });

      setImage(null);
      navigate(`/category/${destinationCategory}`);
    } catch (err) {
      console.error(err);
      alert(
        err?.response?.data?.message ||
          err?.response?.data ||
          "Failed to post item"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex flex-col">

      {/* NAVBAR */}
      <NavBar />

      {/* CENTER WRAPPER */}
      <div className="flex-1 flex items-center justify-center px-4 py-10">

        <div className="w-full max-w-3xl bg-card text-card-foreground rounded-2xl p-8 border border-border shadow-xl">

          {/* HEADER */}
          <div className="mb-6">
            <h2 className="text-3xl font-heading font-bold text-foreground">
              Post an Item
            </h2>

            <p className="text-muted-foreground mt-2">
              Add details and upload an image of your item
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">

            {/* IMAGE */}
            <div
              className="space-y-2"
              required
            >
              <label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                Item Image
              </label>

              <ImageUploader onChange={setImage} />
            </div>

            {/* INPUTS */}
            <input
              name="itemName"
              align="left"
              value={form.itemName}
              onChange={handleChange}
              placeholder="Item Name"
              className="w-full rounded-lg border border-border bg-secondary pl-4 pr-4 py-2.5 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-primary"
              required
            />

            <textarea
              name="description"
              required
              value={form.description}
              onChange={handleChange}
              placeholder="Description"
              rows="4"
              className="w-full rounded-lg border border-border bg-secondary pl-4 pr-4 py-2.5 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-primary"
            />

            {/* PICKUP POINT AND AVAILABILITY */}
            <div className="grid grid-cols-1 gap-4">
              <input
                name="store"
                align="left"
                required
                value={form.store}
                onChange={handleChange}
                placeholder="Pickup Point"
                className="w-full rounded-lg border border-border bg-secondary pl-4 pr-4 py-2.5 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-primary"
              />

              <div className="grid grid-cols-2 gap-2">
                <input
                  type="number"
                  min="1"
                  step="1"
                  required
                  name="availPeriod"
                  value={form.availPeriod}
                  onChange={handleChange}
                  placeholder="Availability"
                  className="w-full rounded-lg border border-border bg-secondary px-4 py-2.5 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-primary"
                />

                <select
                  value={availabilityUnit}
                  onChange={(e) => setAvailabilityUnit(e.target.value)}
                  className="w-full rounded-lg border border-border bg-secondary px-3 py-2.5 text-sm text-foreground focus:outline-none focus:ring-1 focus:ring-primary"
                  aria-label="Availability unit"
                >
                  <option value="hours">Hours</option>
                  <option value="days">Days</option>
                  <option value="months">Months</option>
                  <option value="years">Years</option>
                </select>
              </div>

              <p className="text-xs text-muted-foreground">
                Choose how long the item should remain available.
              </p>
            </div>


            <select
              name="type"
              value={form.type}
              onChange={handleChange}
              readOnly={isPrefilled}
              className={isPrefilled ?
                "opacity-70 cursor-not-allowed w-full rounded-lg border border-border bg-secondary pl-10 pr-4 py-2.5 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-primary" :
                "flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1"}
              required
            >
              <option value="">Select Type</option>

              {types.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>


            {/* CURRENCY AND AMOUNT */}
            <div className="grid grid-cols-2 gap-2">

              {/* CURRENCY */}
              <select
                name="currency"
                required
                value={form.currency}
                onChange={handleChange}
                className="rounded-lg border border-border bg-secondary px-3 py-2.5 text-sm text-foreground focus:outline-none focus:ring-1 focus:ring-primary"
              >
                <option value="">Pick Currency</option>
                <option value="USD">USD</option>
                <option value="UGX">UGX</option>
                <option value="KES">KES</option>
                <option value="TZS">TZS</option>
                <option value="EUR">EUR</option>
                <option value="GBP">GBP</option>
              </select>

              {/* AMOUNT */}
              <input
                type="number"
                name="amount"
                required
                value={form.amount}
                onChange={handleChange}
                placeholder="Amount"
                className="flex-1 rounded-lg border border-border bg-secondary px-4 py-2.5 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-primary"
              />

            </div>

            {/* CATEGORY */}
            <select
              name="categoryName"
              value={form.categoryName}
              onChange={handleChange}
              readOnly={isPrefilled}
              className={isPrefilled ?
                "opacity-70 cursor-not-allowed w-full rounded-lg border border-border bg-secondary pl-10 pr-4 py-2.5 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-primary" :
                "flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1"}
              required
            >
              <option value="">Select Category</option>
              {categories.map(cat => (
                <option key={cat.categoryName} value={cat.categoryName}>
                  {cat.categoryName}
                </option>
              ))}
            </select>

            {/* BUTTON */}
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-primary text-primary-foreground py-3 rounded-xl font-semibold hover:opacity-90 transition shadow-[var(--glow-primary)] disabled:opacity-50"
            >
              {loading ? "Posting..." : "Post Item"}
            </button>

          </form>
        </div>

      </div>
      <Footer/>
    </div>

  );
};

export default PostItem;
